module.exports = __webpack_public_path__ + "img/r_figure_04.05ba3ebb.png";